export default __webpack_public_path__ + "static/classicHover-88af13508a5bceaebcd3eb878e6fd700.png";